import { SITE, whatsappUrl } from "@/config/site";
import { AccessLink, SoonBadge } from "@/components/AccessLink";
import { WhatsAppIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

export default function FloatingWhatsApp() {
  const wa = whatsappUrl();

  return (
    <AccessLink
      href={wa}
      external
      testId="floating-whatsapp-btn"
      showBadge={false}
      ariaLabel={`Conversar com ${SITE.trainerName} no WhatsApp${wa ? "" : " (em breve)"}`}
      className={cn(
        "fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full transition-all hover:scale-105 active:scale-95 aria-disabled:opacity-50",
        wa
          ? "bg-gradient-to-r from-brand-tealight to-brand-blue text-slate-950 shadow-[0_8px_30px_rgba(53,130,124,0.4)]"
          : "cursor-not-allowed border border-white/15 bg-[#0d121c]/90 text-brand-blue backdrop-blur",
      )}
    >
      <WhatsAppIcon className="h-7 w-7" />
      {!wa && (
        <span className="absolute -right-1 -top-2">
          <SoonBadge className="px-2 py-0.5 text-[9px]" />
        </span>
      )}
      <span className="sr-only">
        Conversar com Fernando no WhatsApp{!wa && " (em breve)"}
      </span>
    </AccessLink>
  );
}
